import { Injectable } from '@angular/core';
import { StorageService } from '@shared';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenProviderService {
  private tokenKey = 'AUTHENTICATION_TOKEN';
  private accessTokenKey = 'ACCESS_TOKEN';
  private refreshTokenKey = 'REFRESH_TOKEN';

	public constructor(private storageService: StorageService) {}

	public async save(token: string): Promise<void> {
		await this.storageService.set(this.tokenKey, token);
	}

	public async clearToken(): Promise<void> {
		await this.storageService.remove(this.tokenKey);
	}

	public async get(): Promise<string> {
		return await this.storageService.get(this.tokenKey);
	}

	public get$(): Observable<string> {
		return from(this.storageService.get<string>(this.tokenKey));
	}


  public async saveAccessToken(accessToken: string): Promise<void> {
    await this.storageService.set(this.accessTokenKey, accessToken);
    console.log('Access token saved');
  }

  public async saveRefreshToken(refreshToken: string): Promise<void> {
    await this.storageService.set(this.refreshTokenKey, refreshToken);
    console.log('Refresh token saved');
  }

  public async clearTokens(): Promise<void> {
    await this.storageService.remove(this.accessTokenKey);
    await this.storageService.remove(this.refreshTokenKey);
  }

  public async getAccessToken(): Promise<string> {
    return await this.storageService.get(this.accessTokenKey);
  }

  public async getRefreshToken(): Promise<string> {
    return await this.storageService.get(this.refreshTokenKey);
  }

  public getAccessToken$(): Observable<string> {
    return from(this.storageService.get<string>(this.accessTokenKey));
    console.log('Fetching access token');
  }

  public getRefreshToken$(): Observable<string> {
    return from(this.storageService.get<string>(this.refreshTokenKey));
    console.log('Fetching refresh token');
  }
}
